import { Box, Typography, Paper, CircularProgress, FormControl, Select, MenuItem, Radio } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';

const RightPanel = ({ 
  data, 
  loading, 
  scope, 
  handleScopeChange, 
  blockName = null, 
  blockId = null,
  selectedStatus = null,
  onStatusChange = null 
}) => {
  const { qcPunchlistStatusWiseCounts } = data;

  const rows = [
    { id: 1, status: 'Open', count: qcPunchlistStatusWiseCounts[0], value: 0 },
    { id: 2, status: 'Ready For Inspection', count: qcPunchlistStatusWiseCounts[1], value: 1 },
    { id: 3, status: 'Resolved', count: qcPunchlistStatusWiseCounts[2], value: 2 }
  ];

  const handleRadioChange = (statusValue) => {
    // Only call onStatusChange if it exists (blockDetails page)
    if (onStatusChange) {
      onStatusChange(statusValue);
    }
  };

  // Create columns array conditionally based on whether blockId exists
  const columns = [
    // Only show radio column if blockId exists (blockDetails page)
    ...(blockId ? [{
      field: 'radio',
      headerName: '',
      width: 50,
      headerClassName: 'datagrid-header',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Radio
          checked={selectedStatus === params.row.value}
          onChange={() => handleRadioChange(params.row.value)}
          value={params.row.value}
          name="status-radio-buttons"
          size="small"
          sx={{
            color: '#f16253',
            '&.Mui-checked': {
              color: '#f16253',
            },
          }}
        />
      ),
    }] : []),
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerClassName: 'datagrid-header',
      sortable: false,
      filterable: true,
    },
    {
      field: 'count',
      headerName: 'Counts',
      width: 100,
      headerClassName: 'datagrid-header',
      sortable: false,
      filterable: true,
      renderCell: (params) => {
        if (loading) {
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={20} />
            </Box>
          );
        }
        return params.value;
      }
    }
  ];

  return (
    <Box sx={{ pl: 2, pt: 2 }}>
      <Box mb={2}>
        <Typography fontWeight={600} mb={1} sx={{ fontSize: "18px" }}>Scope</Typography>
        <FormControl sx={{width:"100%" }} size="small">
          <Select
            sx={{ fontSize: "16px" }}
            labelId="scope-select-label"
            id="scope-select"
            value={scope}
            onChange={handleScopeChange}
          >
            {blockId === null || blockId === undefined ? <MenuItem sx={{ fontSize: "16px" }} value="All">All</MenuItem> : null}
            <MenuItem sx={{ fontSize: "16px" }} value="piers">Piers</MenuItem>
            <MenuItem sx={{ fontSize: "16px" }} value="structure">Structure</MenuItem>
            <MenuItem sx={{ fontSize: "16px" }} value="module">Module</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Typography fontWeight={600} mb={1} sx={{ fontSize: "18px" }}>
        {blockName ? `${blockName} - Punchlist` : "Punchlist"}
      </Typography>
      <Paper variant="outlined">
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          hideFooter
          disableColumnMenu
          disableRowSelectionOnClick
          sx={{
            fontSize: "16px",
            width: "100%",
            '& .datagrid-header': {
              backgroundColor: '#f16253',
              color: '#ffffff',
              fontWeight: 600,
            },
            '& .MuiDataGrid-cell': {
              fontSize: '16px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
            },
            border: 0,
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: 'none',
            },
            '& .MuiDataGrid-columnHeader': {
              borderRight: 'none',
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
          }}
        />
      </Paper>
    </Box>
  );
};

export default RightPanel;